import * as Three from 'three';
import React from 'react';

export default {
    name: '[pipe]vertical-gas-pipe',
    prototype: 'holes',

    info: {
        tag: ['structure'],
        title: 'vertical pipe',
        description: 'vertical gas pipe',
        image: require('./verticalPipe.png')
    },

    properties: {
        width: {
            label: 'Width',
            type: 'length-measure',
            defaultValue: {
                length: 30
            }
        },
        length: {
            label: 'Length',
            type: 'length-measure',
            defaultValue: {
                length: 100,
                unit: 'cm'
            }
        },
        diameter: {
            label: "Diameter",
            type: "read-only",
            defaultValue: {
                length: 0,
                unit: 'mm'
            }
        },
        // diameter: {
        //     label: "Diameter",
        //     type: "length-measure",
        //     defaultValue: {
        //         length: 0,
        //         unit: 'cm'
        //     }
        // },
        altitude: {
            label: "Altitude",
            type: "length-measure",
            defaultValue: {
                length: 0,
                unit: 'cm'
            }
        },
        thickness: {
            label: 'thickness',
            type: 'length-measure',
            defaultValue: {
                length: 5
            },
        },
        is_dashedLine: {
            label: 'underground',
            type: 'checkbox',
            defaultValue: false,
            values: {
                'none': false,
                'yes': true
            }
        }
    },

    render2D: function (element, layer, scene) {
        let RADIUS = 5;
        let angle = element.rotation + 90;
        let width = element.properties.get('width').get('length');
        let pipeLength = element.properties.get('length').get('length');
        let unit = element.properties.get('length').get('unit');
        let diameter = element.properties.get('diameter').get('length');
        let diameterText = diameter ? `, Ф${diameter}` : '';
        let distanceText = `${pipeLength.toFixed(2)} ${unit}`;

        let textRotation = 0;
        if (Math.sin(angle * Math.PI / 180) < 0) {
            textRotation = 180;
        }

        let style = { stroke: element.selected ? '#0096fd' : 'black', strokeWidth: "1px", fill: '#ffc617' };

        return (
            <g transform={`scale(${width * 0.05} ${width * 0.05}) translate(-2, 0)`}>
                <circle key='1' cx='0' cy='0' r={RADIUS} style={style} />
                <text key="8" x="0" y="0"
                    transform={`translate(30, -20) scale(1,-1) rotate(${textRotation})`}
                    style={{ textAnchor: "middle", fontSize: "8px", fontFamily: "'Courier New', Courier, monospace", fontWeight: "bold" }}>
                    <tspan>{distanceText}{diameterText}</tspan>
                </text>
            </g>
        )
    },


    render3D: function (element, layer, scene) {
        let mesh = new Three.Mesh();
        return Promise.resolve(mesh);
    },

    renderAxonomertic: function (element, layer, scene, pipeAngle) {

        let pipeLength = element.properties.get('length').get('length');
        let unit = element.properties.get('length').get('unit');
        let diameter = element.properties.get('diameter').get('length');
        let diameterText = diameter ? `, Ф${diameter}` : '';
        let distanceText = `${pipeLength.toFixed(2)} ${unit}`;
        let thickness = element.getIn(['properties', 'thickness', 'length']);
        let altitude = element.getIn(['properties', 'altitude', 'length']);

        // let angle = element.rotation + 90;
        // let textRotation = 0;
        // if (Math.sin(angle * Math.PI / 180) < 0) {
        //     textRotation = 180;
        // }
        let fill = '#777777';
        let isDashed = element.properties.get('is_dashedLine');
        let dashArrayView = (4 * thickness).toString() + " " + (2 * thickness).toString();

        let style = { stroke: element.selected ? '#0096fd' : 'black', strokeWidth: "1px", fill: '#777777' };
        let rotateAngle = 30 - pipeAngle;

        if (!isDashed) {
            return (
                <g transform={`rotate(${rotateAngle})`}>
                    <rect x="0" y={altitude} rx="5" ry="5" width={thickness} height={pipeLength} style={style} fill={fill} transform='scale(1,1.15)' />
                    <text key="8" x="0" y="0"
                        transform={`translate(20, ${pipeLength / 2}) scale(1,-1) rotate(${rotateAngle})`}
                        style={{ textAnchor: "left", fontSize: "11px" }}>
                        <tspan>{distanceText}{diameterText}</tspan>
                    </text>
                </g>
            )
        }
        else {
            return (
                <g transform={`rotate(${rotateAngle})`}>
                    <line x1="0" y1={altitude} x2="0" y2={pipeLength} fill={fill} stroke={fill} strokeWidth={thickness} strokeDasharray={dashArrayView} strokeLinecap="round" transform='scale(1,1.15)' />
                    <text key="8" x="0" y="0"
                        transform={`translate(20, ${pipeLength / 2}) scale(1,-1) rotate(${rotateAngle})`}
                        style={{ textAnchor: "left", fontSize: "11px" }}>
                        <tspan>{distanceText}{diameterText}</tspan>
                    </text>
                </g>
            )
        }
    }

};
